import { toast } from "react-toastify";
import { postApiCall } from "../Handlers/HttpHandler"

export const getById = async(endpoint, id, token, relations = null, withoutIsActiveFilter = false) => {
    let body = {
        offset: 0,
        limit: 1,
        relations: relations,
        values: withoutIsActiveFilter ? {id: id} : {id: id, is_active: "1"}
    }
    let response = await postApiCall(endpoint, body, token);

    if (response.error) {
        toast.error(response.error.message);
        return null;
    }

    if (response.data === null || response.data.data.length === 0) {
        return null;
    }

    return response.data.data[0];
}